<div class="main">
  <app-header *ngIf="headerSubject$ | async" [user]="user"></app-header>
  <!-- <app-version-banner *ngIf="headerSubject$ | async"></app-version-banner> -->
  <app-page-loader></app-page-loader>
  <div class="sub-container">
    <router-outlet></router-outlet>
  </div>
</div>
